import { render } from "./CsvDownloader.vue?vue&type=template&id=09b5dc07"
import script from "./CsvDownloader.vue?vue&type=script&lang=js"
export * from "./CsvDownloader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Tables/CsvDownloader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09b5dc07"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09b5dc07', __exports__)) {
    api.reload('09b5dc07', __exports__)
  }
  
  module.hot.accept("./CsvDownloader.vue?vue&type=template&id=09b5dc07", () => {
    api.rerender('09b5dc07', render)
  })

}


export default __exports__